import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'

function About() {
   const isMdScreen = useMediaQuery("(max-width:1200px)");
   const isSmScreen = useMediaQuery("(max-width:900px)");
   const isXsScreen = useMediaQuery("(max-width:600px)");
  return (
    <section id="about"  style={{ height: isMdScreen ? "auto" : "100vh", paddingTop: isMdScreen ? "20px": 0 ,paddingBottom : isMdScreen ? "20px": 0 , display:"flex",alignItems:"center",    background: "linear-gradient(124deg, rgba(0, 0, 0, 1) 50%, rgba(128, 0, 128, 0.6) 100%)" }}>
<Box
  display="flex"
  justifyContent="center"
  alignItems="center"
  flexDirection="column"
  gap={2}
  width="100%"
>

  <Box display="flex" flexDirection="column" alignItems="center" justifyContent={"center"} sx={{ width: isXsScreen? "80%" : "60%",height:"80%" }}>
    <Typography variant="h4" sx={{ color: "white", paddingBottom: 1, fontWeight: "bold" }}>
      Who Am I?
    </Typography>

    <Box
      sx={{
        //backgroundColor: "#444444",
        border: "rgb(175, 169, 169)",
        boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.3)",
        borderRadius: "12px",
        padding: "16px",
        marginTop: "16px",
        textAlign: "center",
        width: "100%", // Takes full width of the parent (80% of screen)
      }}
    >
      <Typography sx={{ color: "white", paddingX: "5%",fontSize:"18px" }}>
        I am a senior software engineer with expertise in full-stack web development, specializing in both frontend and backend technologies. With several years of experience in the IT industry, I have built responsive, secure, and high-performance web applications for well-known firms, yielding very positive feedback. I write clean, efficient, and well-structured code that transforms ideas into reality. My development approach emphasizes efficient project management techniques, ensuring that my clients have complete visibility and insight throughout the project lifecycle.
      </Typography>

      <Typography variant="h6" sx={{ color: "white", fontWeight: "bold", paddingTop: 1 }}>
        Let's build impactful digital solutions that drive success for your business!
      </Typography>
    </Box>
  </Box>
        {/* Languages Section */}
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ width: isXsScreen? "80%" : "60%", mt: 4 }}>
          <Typography variant="h4" sx={{ color: "white", pb: 2, fontWeight: "bold",textAlign:"center" }}>
            Languages I Use?
          </Typography>

          <Box
            sx={{
              border: "1px solid rgb(175, 169, 169)",
              boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.3)",
              borderRadius: "12px",
              padding: "16px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 2,
              width: "100%",
              maxHeight: "250px",
              // overflowY: "auto"
            }}
          >
            {[
              "html", "css", "js", "react", "angular",
              "sql", "figma", "dotnet"
            ].map((lang, index) => (
              <img key={index} src={`/images/${lang}.png`} alt={lang} style={{ width: isSmScreen ? "50px" : "80px", height: isSmScreen ? "50px" : "80px", borderRadius: "12px" }} />
            ))}
          </Box>
        </Box>
</Box>

    </section>  )
}

export default About